var app = angular.module("leonardo");

var DeleteTasksDialog = function($scope, $rootScope, TaskService, FormErrorsService) {
  $scope.filters = $scope.ngDialogData.filters;
  
  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    TaskService.clearPastDue($scope.filters).then(function() {
      $rootScope.$broadcast('delete-past-due-tasks:updated');
      $scope.closeThisDialog();
    });
  };

};

app.controller('DeleteTasksDialog', ['$scope', '$rootScope', 'TaskService', 'FormErrorsService', DeleteTasksDialog]);
